import React from 'react';

import LazyImgixImage from '@components/LazyImgixImage';
import useEventTracking from '@hooks/useEventTracking';
import { article_path } from '@routes';
import { ClickTarget, ContentType, click } from '@tracking';
import { articlePath } from '@utils/queryStringHelper';

import type { RecommendedArticlesBlockProps } from './interfaces';

const ArticleItem = ({
  article: { authors, id, picture_url_small, slug, title, newsletterSlug },
}: RecommendedArticlesBlockProps) => {
  const { trackEvent } = useEventTracking({
    contentType: ContentType.Article,
  });

  const handleArticleClick = () => {
    trackEvent(click({ clickTarget: ClickTarget.ArticleImage, contentId: id }));
  };

  const handleArticleTitleClick = () => {
    trackEvent(click({ clickTarget: ClickTarget.Headline, clickText: title, contentId: id }));
  };

  return (
    <div className="flex flex-col pb-40 last:pb-0 sm:w-[calc(50vw-80px)] sm:pb-0 lg:w-[257px]">
      <a
        href={article_path(slug)}
        className="relative mb-8 block h-[calc((100vw-2rem)*9/16)] sm:mb-0 sm:h-[calc((50vw-80px)*9/16)] lg:h-[calc(257px*9/16)]"
        onClickCapture={handleArticleClick}
      >
        <LazyImgixImage
          className="m-auto block aspect-[16/9] h-auto w-full"
          src={picture_url_small}
          sizes="(min-width: 768px) 250px, (min-width: 480px) 500px, 400px"
          wrapperClassName="h-full w-full"
        />
      </a>
      <div className="mt-8 sm:mt-12">
        <h2 className="pro-article-title m-0 font-suisse-works text-headline-xs text-black lg:text-headline-xxs">
          <a
            href={articlePath({ slug: slug, newsletterSlug: newsletterSlug })}
            className="text-primary-black"
            onClickCapture={handleArticleTitleClick}
          >
            {title}
          </a>
        </h2>
        <p className="mb-0 mt-2 !font-suisse-screen !text-byline-sm text-grayscale-gray">
          By {authors}
        </p>
      </div>
    </div>
  );
};

export default ArticleItem;
